/**
 * pgc视频路由
 */
"use strict";
angular.module("videoRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("video", {
        url: "/video?id&type",
        views: {
            "": {
                 template: '<div class="view_head" ui-view="header"></div>' +
	                      '<div class="view_body">' +
	                      '<div class="" ui-view="main"></div>' +
	                      '</div>'
            },
            "header@video": {
                templateUrl: 'header/headerDetails_tpl.html',
                controller: 'webHeaderCtrl'
            },
            "main@video": {
                templateUrl: "./main/submissionManage/personalLibrary/video/video_tpl.html",
                controller: "videoCtrl"
            }
        }
    }).state("videodetail", {
        url: "/videodetail?articleId&type",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
	                      '<div class="view_body">' +
	                      '<div class="" ui-view="main"></div>' +
	                      '</div>'
            },
            "header@videodetail": {
                 templateUrl: 'header/headerDetails_tpl.html',
                controller: 'webHeaderCtrl'
            },
            "main@videodetail": {
                templateUrl: "./main/submissionManage/personalLibrary/video/videoDetail/videoDetail_tpl.html",
                controller: "videoDetailCtrl"
            }
        }
    });;
}]);